import { DbListBase } from './db-list-base';
import { DbLotteryFilter, DbLotteryFilterGroup, DbLotteryFilterParam } from './db-lottery-filter';
import { ICollectionReference } from '../database-cast/IDatabase';

export class DbCustomerLotteryFilterGroups extends DbListBase<any> {
   // private _collection: ICollectionReference;

    constructor(collection: ICollectionReference) {
        super(collection);
    //    this._collection = collection;
    }

    // public getParams() {
    //     let params = new DbCustomerLotteryFiltersParams(this._collection.doc("params"));

    //     return params;
    // }

    public getFilterGroup(id:string) {
        let params = new DbLotteryFilterGroup(id,this._collection);

        return params;
    }

}

